// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skeleton div[data-v-4dbd9664]{background-color:#eee;height:1rem;margin:.5rem 0;width:85%}.skeleton div[data-v-4dbd9664]:last-child{width:35%}", ""]);
// Exports
module.exports = exports;
